// Unit as seen in data
export enum Unit {
  Bar = 'bar',
  Ampere = 'ampere',
  AmpereHour = 'ampereHour',
  Celsius = 'celsius',
  Fahrenheit = 'fahrenheit',
  CubicMeter = 'cubicMeter',
  CubicMeterPerHour = 'cubicMeter/hour',
  CubicFeet = 'cubicFeet',
  CubicFeetPerHour = 'cubicFeet/hour',
  Dbm = 'dBm',
  Decibar = 'decibar',
  Hour = 'hour',
  Hours = 'hours',
  Kilogram = 'kilogram',
  ShortKilogram = 'kg',
  Ton = 'ton',
  ShortTon = 't',
  Kelvin = 'kelvin',
  KelvinPerMinute = 'kelvin/min',
  Watt = 'watt',
  ShortWatt = 'W',
  WattHour = 'wattHour',
  WattHours = 'watt_hours',
  ShortWattHour = 'Wh',
  Kilowatt = 'kilowatt',
  KilowattHour = 'kilowattHour',
  ShortKilowatt = 'kW',
  ShortKilowattHour = 'kWh',
  Megawatt = 'megawatt',
  ShortMegawatt = 'MW',
  MegawattHour = 'megawattHour',
  ShortMegawattHour = 'MWh',
  Voltage = 'volt',
  KilowattPeak = 'kilowattpeak',
  Liter = 'liter',
  LiterMinute = 'liter/minute',
  LiterHour = 'liter/hour',
  Galoon = 'galoon',
  GaloonMinute = 'gallon/minute',
  GaloonHour = 'gallon/hour',
  Minute = 'minute',
  MilliAmpere = 'milliAmpere',
  Strength = 'strength',
  PartsPerMillion = 'partsPerMillion',
  PoundPerSquareInch = 'poundPerSquareInch',
  DeciPoundPerSquareInch = 'deciPointPerSquareInch', //artificial
  Percent = 'percent',
  ShortPercent = '%',
  Kilometre = 'kilometre',
  PC = 'pc', //??
  RotationPerMinute = 'rotationPerMinute',
  Rps = 'rps',
  RevolutionsPerSecond = 'revolutionsPerSecond',
  NoUnit = 'noUnit',
  Ohm = 'ohm',
  kelvinMinute = 'kelvinMinute',
}

// Unit as displayed in the view
export enum SUFFIX {
  wattHour = 'Wh',
  wattHours = 'Wh',
  kilowattHour = 'kWh',
  megawattHour = 'MWh',
  kilowattPeak = 'kWp',
  litersPerHour = 'l/h',
  liter = 'l',
  gallon = 'gal',
  percentage = '%',
  watt = 'W',
  kilowatt = 'kW',
  megawatt = 'MW',
  voltage = 'V',
  hour = 'h',
  bar = 'bar',
  psi = 'psi',
  decibelMilliWatt = 'dBm',
  cubicMeter = 'm³',
  cubicMeterPerHour = 'm³/h',
  cubicFeet = 'ft³',
  cubicFeetPerHour = 'ft³/h',
  galoon = 'gal',
  gallonPerMinute = 'gpm',
  galloonPerHour = 'gal/h',
  kilogram = 'kg',
  ton = 't',
  kilometre = 'km',
  celsius = '°C',
  fahrenheit = '°F',
  partsPerMillion = 'ppm',
  kelvin = 'K',
  kelvinPerMinute = 'K/min',
  minute = 'min',
  percentageMinutePerKelvin = 'K/min',
  poundPerSquareInch = 'psi',
  litersPerMinute = 'l/min',
  ampere = 'A',
  ampereHour = 'Ah',
  milliAmpere = 'mA',
  rotationPerMinute = 'rpm', //Save it in case of in the future we need it 'min⁻¹'
  rps = 'rps',
  noUnit = '',
  kilowattHourPerCubicMeter = 'kWh/m³',
  ohm = 'Ohm',
  kelvinMinute = 'K*min',
}

export function convertCelsiusToFahrenheit(celsius: number): number {
  return (celsius * 9) / 5 + 32;
}

export function convertFahrenheitToCelsius(fahrenheit: number): number {
  return ((fahrenheit - 32) * 5) / 9;
}
